import { LucideIcon } from "lucide-react";
import { getIconComponentWithFallback } from "../utils/iconMapping";

// Component for rendering navigation item icons
export function NavItemIcon({ icon }: { icon?: string | LucideIcon }) {
	if (!icon) return null;

	const IconComponent =
		typeof icon === "string" ? getIconComponentWithFallback(icon) : icon;

	return <IconComponent />;
}
